export default {
    PROPERTY_VALUE_HIGH: 'property-value-high',
    PROPERTY_OLD: 'property-old',
    COVERAGE_CHANGE: 'coverage-change',
    BROKER_CONTACT: 'broker-contact',
    VACANT_PROPERTY: 'vacant-property',
    HOME_BUSINESS_VIOLATION: 'home-business-violation',
    NON_APPROVED_RESIDENTS: 'non-approved-residents',
    POSTAL_CODE_RESTRICTIONS: 'postal-code-restrictions',
    NON_PAYMENT_PREMIUMS: 'non-payment-premiums',
    NON_DISCLOSURE: 'non-disclosure',
    MISREPRESENTATION: 'misrepresentation',
    OTHER: 'other',
};
